module.exports = "/_next/static/files/a3165c6bcbfed9915678dcd3c6ead30d.png";